import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c5b50a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-circle-left" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "row-wrapper meeting-actions"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "grid-container" }
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = { class: "pt-2" }
const _hoisted_10 = { class: "member-meeting-info" }
const _hoisted_11 = { class: "form-item case-number" }
const _hoisted_12 = { class: "form-item member-status" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details-btn-wrapper" }, "Details", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsButton = _resolveComponent("AsButton")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_AsBlock = _resolveComponent("AsBlock")!
  const _component_AsDatepicker = _resolveComponent("AsDatepicker")!
  const _component_AsDropdown = _resolveComponent("AsDropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AsBlock, { class: "row-wrapper-space-between group-meeting" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "back cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToGroup && _ctx.navigateToGroup(...args)))
          }, _hoisted_3),
          _createTextVNode(" " + _toDisplayString(`${_ctx.$t('group.group')}: ${_ctx.groupMeeting.groupName}`), 1)
        ]),
        (_ctx.isMeetingActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_AsButton, {
                type: _ctx.bTypes.Danger,
                label: _ctx.$t('cancel'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelGroupMeeting($event)))
              }, null, 8, ["type", "label"]),
              _createVNode(_component_AsButton, {
                type: _ctx.bTypes.Primary,
                disabled: !_ctx.isFormValid,
                label: _ctx.$t('save'),
                onClick: _ctx.updateGroupMeeting
              }, null, 8, ["type", "disabled", "label", "onClick"]),
              _createVNode(_component_ConfirmPopup)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.groupMeeting.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_AsBlock, {
            class: "",
            header: _ctx.$t('group.meetingDetails')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_AsDatepicker, {
                    placeholder: _ctx.$t('date'),
                    value: _ctx.groupMeeting.meetingDate,
                    label: _ctx.$t('date'),
                    enableTimePicker: false,
                    disabled: !_ctx.isMeetingActive,
                    onUpdate: _cache[2] || (_cache[2] = (date) => (_ctx.groupMeeting.meetingDate = date))
                  }, null, 8, ["placeholder", "value", "label", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AsDropdown, {
                    placeholder: _ctx.$t('group.meetingType'),
                    label: _ctx.$t('group.meetingType'),
                    clearIcon: true,
                    value: _ctx.groupMeeting.meetingTypeId,
                    optionValue: 'id',
                    optionLabel: 'value',
                    options: _ctx.getLookUpOptions(_ctx.lvTypes.GroupMeeting),
                    disabled: !_ctx.isMeetingActive,
                    onUpdate: _cache[3] || (_cache[3] = (value) => (_ctx.groupMeeting.meetingTypeId = value))
                  }, null, 8, ["placeholder", "label", "value", "options", "disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_AsBlock, {
            class: "",
            header: _ctx.$t('group.generalNotes')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Textarea, {
                class: "full-width",
                rows: "4",
                modelValue: _ctx.groupMeeting.notes,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.groupMeeting.notes) = $event)),
                disabled: !_ctx.isMeetingActive,
                autoResize: true
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_AsBlock, {
            class: "",
            header: _ctx.$t('members')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupMeeting.meetingMembers, (member) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "pb-1",
                    key: member.id
                  }, [
                    _createVNode(_component_AsBlock, null, {
                      standAloneHeader: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_fa, { icon: "icon fa-regular fa-user " }),
                            _createElementVNode("div", null, _toDisplayString(member.caseNumber), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_AsDropdown, {
                              placeholder: 'Status',
                              clearIcon: true,
                              disabled: !_ctx.isMeetingActive,
                              value: member.historyItem.meetingStatus,
                              options: _ctx.meetingMemberOptions,
                              onUpdate: (value) => (member.historyItem.meetingStatus = value)
                            }, null, 8, ["disabled", "value", "options", "onUpdate"])
                          ]),
                          _createElementVNode("div", {
                            class: "details-btn cursor-pointer",
                            onClick: ($event: any) => (_ctx.openCaseDetails(member.caseId))
                          }, _hoisted_15, 8, _hoisted_13)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Textarea, {
                          class: "full-width",
                          disabled: !_ctx.isMeetingActive,
                          rows: "4",
                          modelValue: member.historyItem.text,
                          "onUpdate:modelValue": ($event: any) => ((member.historyItem.text) = $event),
                          autoResize: true
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}